import { filterNonAstNodes } from '../parser';
import { assert } from '../util/todo';
import { buildExpr } from './expr';
import { buildParam } from './index';
import { buildPattern } from './match';
import { buildIdentifier, buildName } from './operand';
import { buildGeneric, buildType } from './type';
import { buildTypeDef } from './type-def';
export const buildStatement = (node) => {
    const n = filterNonAstNodes(node)[0];
    switch (n.kind) {
        case 'var-def':
            return buildVarDef(n);
        case 'fn-def':
            return buildFnDef(n);
        case 'trait-def':
            return buildTraitDef(n);
        case 'impl-def':
            return buildImplDef(n);
        case 'type-def':
            return buildTypeDef(n);
        case 'return-stmt':
            return buildReturnStmt(n);
        case 'break-stmt':
            return buildBreakStmt(n);
        case 'expr':
            return buildExpr(n);
    }
    throw Error(`expected statement, got ${node.kind}`);
};
export const buildUseExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    let i = 0;
    const pub = nodes[i].kind === 'pub-keyword';
    if (pub)
        i++;
    // skip use keyword
    if (nodes[i].kind === 'use-keyword')
        i++;
    if (nodes[i].kind === 'use-expr') {
        const expr = buildUseExpr(nodes[i]);
        expr.pub = pub;
        return expr;
    }
    const names = nodes
        .slice(i)
        .filter(n => n.kind === 'name')
        .map(buildName);
    const lastNode = nodes.at(-1);
    if (lastNode.kind === 'use-list') {
        const scope = names;
        return { kind: 'use-expr', parseNode: node, scope, expr: filterNonAstNodes(lastNode).map(buildUseExpr), pub };
    }
    return { kind: 'use-expr', parseNode: node, scope: names.slice(0, -1), expr: names.at(-1), pub };
};
export const buildVarDef = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    const pub = nodes[idx].kind === 'pub-keyword';
    if (pub)
        idx++;
    // skip let-keyword
    idx++;
    const pattern = buildPattern(nodes[idx++]);
    const varType = nodes.at(idx)?.kind === 'type-annot' ? buildType(filterNonAstNodes(nodes[idx++])[0]) : undefined;
    const expr = nodes.at(idx)?.kind === 'expr' ? buildExpr(nodes[idx++]) : undefined;
    return { kind: 'var-def', parseNode: node, pattern, varType, expr, pub };
};
export const buildFnDef = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    const pub = nodes[idx].kind === 'pub-keyword';
    if (pub)
        idx++;
    // skip fn-keyword
    idx++;
    const name = buildName(nodes[idx++]);
    const generics = nodes.at(idx)?.kind === 'generics' ? filterNonAstNodes(nodes[idx++]).map(buildGeneric) : [];
    const params = nodes.at(idx)?.kind === 'params' ? filterNonAstNodes(nodes[idx++]).map(buildParam) : [];
    const returnType = nodes.at(idx)?.kind === 'type-annot' ? buildType(nodes[idx++]) : undefined;
    const block = nodes.at(idx)?.kind === 'block' ? buildBlock(nodes[idx++]) : undefined;
    return { kind: 'fn-def', parseNode: node, name, generics, params, block, returnType, pub };
};
export const buildTraitDef = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    const pub = nodes[idx].kind === 'pub-keyword';
    if (pub)
        idx++;
    // skip trait-keyword
    idx++;
    const name = buildName(nodes[idx++]);
    const generics = nodes.at(idx)?.kind === 'generics' ? filterNonAstNodes(nodes[idx++]).map(buildGeneric) : [];
    const block = buildBlock(nodes[idx++]);
    return { kind: 'trait-def', parseNode: node, name, generics, block, pub };
};
export const buildImplDef = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    // skip impl-keyword
    idx++;
    const generics = nodes.at(idx)?.kind === 'generics' ? filterNonAstNodes(nodes[idx++]).map(buildGeneric) : [];
    const identifier = buildIdentifier(nodes[idx++]);
    const forTrait = nodes.at(idx)?.kind === 'impl-for' ? buildIdentifier(filterNonAstNodes(nodes[idx++])[1]) : undefined;
    const block = buildBlock(nodes[idx++]);
    return { kind: 'impl-def', parseNode: node, identifier, generics, forTrait, block };
};
export const buildReturnStmt = (node) => {
    const nodes = filterNonAstNodes(node);
    assert(nodes[0].kind === 'return-keyword');
    const returnExpr = buildExpr(nodes[1]);
    return { kind: 'return-stmt', parseNode: node, returnExpr };
};
export const buildBreakStmt = (node) => {
    return { kind: 'break-stmt', parseNode: node };
};
export const buildBlock = (node) => {
    const statements = filterNonAstNodes(node).map(buildStatement);
    return { kind: 'block', parseNode: node, statements };
};
//# sourceMappingURL=statement.js.map